import { useQuery } from "react-query";
import { CampoSeletorOption, CampoSeletorOptions } from "./CampoSeletor";
import axios from "axios";
import React from "react";

type Props = {
    usuarioId?: number | null;
    grupoId?: number | null;
    onUsuarioIdChange?: (id: number | null) => void;
    onGrupoIdChange?: (id: number | null) => void;
}


export const SeletorUsuarioGrupo = ({
    usuarioId,
    grupoId,
    onUsuarioIdChange = () => { },
    onGrupoIdChange = () => { },
}: Props) => {
    const [search, setSearch] = React.useState<string>('');

    const queryUsuarios = useQuery<any[]>('usuario', async () => {
        const result = await axios.get('/api/usuario/box');
        return result.data?.result;
    });

    const atendentes =
        queryUsuarios?.data
            ?.reduce(
                (acc: CampoSeletorOption[], it: any) => {
                    if (it.grupos) {
                        for (const g of it.grupos) {
                            if (g.aceita_atendimento === false) continue;
                            acc.push(
                                ({
                                    id: it.id.toString(),
                                    label: it.nome,
                                    group: g.nome,
                                    groupId: g.id.toString(),
                                }) as CampoSeletorOption
                            )
                        }
                    }
                    return acc
                },
                [],
            )?.sort((a: CampoSeletorOption, b: CampoSeletorOption) => `${a.group}--${a.label}`.localeCompare(`${b.group}--${b.label}`)) ?? [];

    return (
        <CampoSeletorOptions
            value={atendentes}
            selectedId={usuarioId?.toString() ?? null}
            selectedGroupId={grupoId?.toString() ?? null}
            onSelect={value => {
                onUsuarioIdChange(value ? parseInt(value) : null);
                onGrupoIdChange(null);
            }}
            onGroupSelect={value => {
                onGrupoIdChange(value ? parseInt(value) : null);
                onUsuarioIdChange(null);
            }}
            search={search}
            onChangeSearch={setSearch}
        />
    )
}